import { ReceiptModel } from "./receiptModel";
import { FeeReceiptData } from "./receiptService";

// Tuition fee receipt -> generic receipt. Due is what was owed on the included terms just before this
// payment (paid + concession + balance), so Due - Concession - Paid always equals the term balance.
export const toFeeReceiptModel = (receipt: FeeReceiptData): ReceiptModel => {
  const paid = receipt.amount ?? 0;
  const concession = receipt.discount ?? 0;
  const balance = receipt.balance ?? 0;
  const isCash = (receipt.paymentMode ?? "").toUpperCase() === "CASH";

  return {
    receiptNo: receipt.receiptNo,
    receiptDate: receipt.receiptDate,
    student: {
      name: receipt.name,
      admissionNo: receipt.admissionNo,
      className: `${receipt.grade} - ${receipt.section}`,
      academicYear: receipt.academicYear ?? undefined,
    },
    items: [{ description: "Tuition Fee", terms: receipt.terms || undefined, due: paid + concession + balance, concession, paid }],
    payment: {
      mode: receipt.paymentMode,
      transactionId: !isCash && receipt.transactionId ? receipt.transactionId : undefined,
      date: receipt.paymentDate ?? undefined,
      balance: balance > 0 ? { label: receipt.balanceTerm ? `Term ${receipt.balanceTerm} Balance` : "Balance", amount: balance } : undefined,
    },
    totalPaid: paid,
    signedBy: receipt.paidOnlineBy
      ? { label: "Paid online by", name: receipt.paidOnlineBy }
      : receipt.receivedBy
        ? { label: "Received By", name: receipt.receivedBy }
        : undefined,
  };
};
